<template>
  <EditDialog
    :visible="visible"
    :title="$t('organization_structure.edit_tag')"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <v-form v-if="form.tag.id" v-model="form.valid" ref="edit_tag_form">
        <v-text-field
          required
          outlined
          dense
          data-private
          autofocus
          v-model="form.tag.name"
          :hideDetails="Boolean(form.tag.name)"
          :class="Boolean(form.tag.name) ? 'mb-4' : ''"
          :rules="[
            name => !!name || $t('validation.form.this_field_is_required'),
          ]"
          :label="`${$t('common.tag_name')}*`"
        />
        <MultipleSelect
          v-if="tagGroups"
          hideDetails
          itemValue="id"
          :label="$t('common.tag_group_other')"
          :value="form.tag.groups"
          :options="tagGroupsOptions"
          :loading="loading"
          @change="form.tag.groups = $event"
        />
        <div class="d-flex align-center mt-4">
          <p class="blue-grey--text text--darken-3 ma-0 pa-0 me-2">
            {{ $t('common.enabled') }}
          </p>
          <v-switch
            class="mt-0 pt-0"
            hide-details
            v-model="form.tag.isEnabled"
            :ripple="false"
          />
        </div>
        <div class="d-flex align-center mt-4">
          <p class="blue-grey--text text--darken-3 ma-0 pa-0 me-2">
            {{ $t('organization_structure.global_tag') }}
          </p>
          <v-switch
            class="mt-0 pt-0"
            hide-details
            :ripple="false"
            :value="global"
            :input-value="global"
            @change="handleGlobalSwitch"
          />
        </div>
        <MultipleSelect
          hideDetails
          class="mt-4"
          v-if="!global"
          :label="$t('common.site_other')"
          :value="tagSites"
          :options="sitesOptions"
          :loading="loading"
          @change="form.tag.sites = $event"
        />
      </v-form>
    </template>
    <template v-slot:footer>
      <div>
        <v-btn
          text
          rounded
          class="me-2"
          color="blue-grey"
          @click="$emit('close')"
          >{{ $t('common.button.cancel') }}</v-btn
        >

        <v-btn
          rounded
          elevation="0"
          color="blue"
          class="white--text"
          :disabled="loading"
          @click="handleSave"
          >{{ $t('common.button.save') }}</v-btn
        >
      </div>
    </template>
  </EditDialog>
</template>

<script>
import MultipleSelect from '@/components/Core/MultipleSelect.vue'

import EditDialog from '@/containers/OrganizationStructureView/Shared/EditDialog.vue'

export default {
  name: 'EditTagDialog',

  components: {
    MultipleSelect,
    EditDialog,
  },

  props: {
    loading: Boolean,
    visible: Boolean,
    tag: {
      type: Object,
      required: false,
      default: () => {
        return { name: '', groups: [], sites: [], id: '' }
      },
    },
    sites: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
    groups: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },

  data() {
    return {
      global: false,
      form: {
        valid: true,
        tag: {
          name: '',
          groups: [],
          sites: [],
          id: '',
        },
      },
    }
  },

  watch: {
    tag(newVal) {
      this.form.tag = { ...newVal }

      this.global = !newVal?.sites?.length
    },
  },

  computed: {
    tagSites() {
      return this.form?.tag?.sites?.map(site => site?._id ?? site?.id ?? site)
    },

    tagGroups() {
      //we are going to wait for the backend to implement a new endpoint for this field
      return false
    },

    tagGroupsOptions() {
      return this.groups.filter(group => group.isEnabled)
    },

    sitesOptions() {
      return this.sites.filter(site => site.isEnabled)
    },
  },

  methods: {
    handleGlobalSwitch(global) {
      this.global = global
      if (global) this.form.tag.sites = []
    },

    handleSave() {
      this.$refs.edit_tag_form.validate()
      if (!this.form.valid) return
      this.$emit('save', this.form.tag)
      this.resetForm()
    },

    resetForm() {
      this.form.tag = {
        name: '',
        groups: [],
        sites: [],
        id: '',
      }
      this.$refs?.edit_tag_form?.reset?.()
    },
  },
}
</script>
